import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

export const INITIAL_STATE = Immutable({
  isLoading: false,
  accessLevelsHasDuplicatesisLoading: false,
  successMessage: null,
  errorMessage: null,
  accessLevels: [],
  totalElements: 0,
  createdId: null,
  accessLevelControllers: [],
  allControllers: [],
  multipleAccessLevelControllers: [],
  accessLevelsHasDuplicates: false,
});

const { Types, Creators } = createActions({
  getAccessLevelsRequest: ['customerId', 'pageParams'],
  getAccessLevelsRequestSuccess: ['accessLevels', 'totalElements'],
  getAccessLevelsRequestFailure: ['errorMessage'],

  createAccessLevelRequest: ['accessLevelInfos', 'customerId', 'pageParams'],
  createAccessLevelRequestSuccess: ['createdId', 'accessLevels', 'totalElements', 'successMessage'],
  createAccessLevelRequestFailure: ['errorMessage'],

  editAccessLevelRequest: ['accessLevelInfos', 'customerId', 'pageParams'],
  editAccessLevelRequestSuccess: ['accessLevels', 'totalElements', 'successMessage'],
  editAccessLevelRequestFailure: ['errorMessage'],

  deleteAccessLevelRequest: ['accessLevelId', 'customerId', 'pageParams'],
  deleteAccessLevelRequestSuccess: ['accessLevels', 'totalElements', 'successMessage'],
  deleteAccessLevelRequestFailure: ['errorMessage'],

  getAccessLevelControllersRequest: ['accessLevelId'],
  getAccessLevelControllersRequestSuccess: ['accessLevelControllers'],
  getAccessLevelControllersRequestFailure: ['errorMessage'],

  getMultipleAccessLevelControllersRequest: ['accessLevelIds'],
  getMultipleAccessLevelControllersRequestSuccess: ['multipleAccessLevelControllers', 'accessLevelsHasDuplicates'],
  getMultipleAccessLevelControllersRequestFailure: ['errorMessage'],

  addControllersToAccessLevelRequest: ['accessLevelId', 'controllers'],
  addControllersToAccessLevelRequestSuccess: ['accessLevelControllers', 'successMessage'],
  addControllersToAccessLevelRequestFailure: ['errorMessage'],

  deleteAccessLevelControllersRequest: ['accessLevelId', 'controllers'],
  deleteAccessLevelControllersRequestSuccess: ['accessLevelControllers', 'successMessage'],
  deleteAccessLevelControllersRequestFailure: ['errorMessage'],

  resetAccessLevels: null,
  resetControllers: null,
});

export const getAccessLevelsRequest = (state, { customerId, pageParams }) =>
  state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const getAccessLevelsRequestSuccess = (state, { accessLevels, totalElements }) =>
  state.merge({ isLoading: false, accessLevels, totalElements });
export const getAccessLevelsRequestFailure = (state, { errorMessage }) =>
  state.merge({ isLoading: false, errorMessage });

export const createAccessLevelRequest = (state) =>
  state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const createAccessLevelRequestSuccess = (state, { createdId, accessLevels, totalElements, successMessage }) =>
  state.merge({ isLoading: false, createdId, accessLevels, totalElements, successMessage });
export const createAccessLevelRequestFailure = (state, { errorMessage }) =>
  state.merge({ isLoading: false, errorMessage });

export const editAccessLevelRequest = (state) =>
  state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const editAccessLevelRequestSuccess = (state, { accessLevels, totalElements, successMessage }) =>
  state.merge({ isLoading: false, accessLevels, totalElements, successMessage });
export const editAccessLevelRequestFailure = (state, { errorMessage }) =>
  state.merge({ isLoading: false, errorMessage });

export const deleteAccessLevelRequest = (state) =>
  state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const deleteAccessLevelRequestSuccess = (state, { accessLevels, totalElements, successMessage }) =>
  state.merge({ isLoading: false, accessLevels, totalElements, successMessage });
export const deleteAccessLevelRequestFailure = (state, { errorMessage }) =>
  state.merge({ isLoading: false, errorMessage });

export const getAccessLevelControllersRequest = (state) =>
  state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const getAccessLevelControllersRequestSuccess = (state, { accessLevelControllers }) =>
  state.merge({ isLoading: false, accessLevelControllers });
export const getAccessLevelControllersRequestFailure = (state, { errorMessage }) =>
  state.merge({ isLoading: false, errorMessage });

export const getMultipleAccessLevelControllersRequest = (state) =>
  state.merge({ accessLevelsHasDuplicatesisLoading: true, isLoading: true, successMessage: null, errorMessage: null });
export const getMultipleAccessLevelControllersRequestSuccess = (
  state,
  { multipleAccessLevelControllers, accessLevelsHasDuplicates }
) =>
  state.merge({
    accessLevelsHasDuplicatesisLoading: false,
    isLoading: false,
    multipleAccessLevelControllers,
    accessLevelsHasDuplicates,
  });
export const getMultipleAccessLevelControllersRequestFailure = (state, { errorMessage }) =>
  state.merge({ isLoading: false, errorMessage });

export const addControllersToAccessLevelRequest = (state) =>
  state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const addControllersToAccessLevelRequestSuccess = (state, { accessLevelControllers, successMessage }) =>
  state.merge({ isLoading: false, accessLevelControllers, successMessage });
export const addControllersToAccessLevelRequestFailure = (state, { errorMessage }) =>
  state.merge({ isLoading: false, errorMessage });

export const deleteAccessLevelControllersRequest = (state) =>
  state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const deleteAccessLevelControllersRequestSuccess = (state, { accessLevelControllers, successMessage }) =>
  state.merge({ isLoading: false, accessLevelControllers, successMessage });
export const deleteAccessLevelControllersRequestFailure = (state, { errorMessage }) =>
  state.merge({ isLoading: false, errorMessage });

export const resetAccessLevels = (state) => state.merge({ accessLevels: [], totalElements: 0 });
export const resetControllers = (state) => state.merge({ accessLevelControllers: [], allControllers: [] });

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_ACCESS_LEVELS_REQUEST]: getAccessLevelsRequest,
  [Types.GET_ACCESS_LEVELS_REQUEST_SUCCESS]: getAccessLevelsRequestSuccess,
  [Types.GET_ACCESS_LEVELS_REQUEST_FAILURE]: getAccessLevelsRequestFailure,

  [Types.CREATE_ACCESS_LEVEL_REQUEST]: createAccessLevelRequest,
  [Types.CREATE_ACCESS_LEVEL_REQUEST_SUCCESS]: createAccessLevelRequestSuccess,
  [Types.CREATE_ACCESS_LEVEL_REQUEST_FAILURE]: createAccessLevelRequestFailure,

  [Types.EDIT_ACCESS_LEVEL_REQUEST]: editAccessLevelRequest,
  [Types.EDIT_ACCESS_LEVEL_REQUEST_SUCCESS]: editAccessLevelRequestSuccess,
  [Types.EDIT_ACCESS_LEVEL_REQUEST_FAILURE]: editAccessLevelRequestFailure,

  [Types.DELETE_ACCESS_LEVEL_REQUEST]: deleteAccessLevelRequest,
  [Types.DELETE_ACCESS_LEVEL_REQUEST_SUCCESS]: deleteAccessLevelRequestSuccess,
  [Types.DELETE_ACCESS_LEVEL_REQUEST_FAILURE]: deleteAccessLevelRequestFailure,

  [Types.GET_ACCESS_LEVEL_CONTROLLERS_REQUEST]: getAccessLevelControllersRequest,
  [Types.GET_ACCESS_LEVEL_CONTROLLERS_REQUEST_SUCCESS]: getAccessLevelControllersRequestSuccess,
  [Types.GET_ACCESS_LEVEL_CONTROLLERS_REQUEST_FAILURE]: getAccessLevelControllersRequestFailure,

  [Types.GET_MULTIPLE_ACCESS_LEVEL_CONTROLLERS_REQUEST]: getMultipleAccessLevelControllersRequest,
  [Types.GET_MULTIPLE_ACCESS_LEVEL_CONTROLLERS_REQUEST_SUCCESS]: getMultipleAccessLevelControllersRequestSuccess,
  [Types.GET_MULTIPLE_ACCESS_LEVEL_CONTROLLERS_REQUEST_FAILURE]: getMultipleAccessLevelControllersRequestFailure,

  [Types.ADD_CONTROLLERS_TO_ACCESS_LEVEL_REQUEST]: addControllersToAccessLevelRequest,
  [Types.ADD_CONTROLLERS_TO_ACCESS_LEVEL_REQUEST_SUCCESS]: addControllersToAccessLevelRequestSuccess,
  [Types.ADD_CONTROLLERS_TO_ACCESS_LEVEL_REQUEST_FAILURE]: addControllersToAccessLevelRequestFailure,

  [Types.DELETE_ACCESS_LEVEL_CONTROLLERS_REQUEST]: deleteAccessLevelControllersRequest,
  [Types.DELETE_ACCESS_LEVEL_CONTROLLERS_REQUEST_SUCCESS]: deleteAccessLevelControllersRequestSuccess,
  [Types.DELETE_ACCESS_LEVEL_CONTROLLERS_REQUEST_FAILURE]: deleteAccessLevelControllersRequestFailure,

  [Types.RESET_ACCESS_LEVELS]: resetAccessLevels,
  [Types.RESET_CONTROLLERS]: resetControllers,
});

export const AccessLevelsTypes = Types;
export default Creators;
